<div class="container-md p-md-0">
  <ts-asset-selection
    header="{{ 'my_eligible_devices' | translate }}"
    no_asset_text="{{ 'no_eligible_devices' | translate }}"
    [asset_fields]="['plan', 'add_on_features', 'contract_end_date', 'upgrade_eligible_date']"
    [existing_asset]="existing_asset"
    (asset_selection_emit)="selectAsset($event)"
  />
</div>

<ng-template #confirmUpgradeEligibleModal>
  <ts-confirm-upgrade-eligible
    modal_header="{{ 'upgrade_device' | translate }}"
    [asset]="active_asset"
    (confirm_upgrade_eligible)="continueToUpgradeDevice($event)"
  />
</ng-template>

<!-- 1DML Modal -->
<ng-template #multiSimDeviceModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'multisim_device' | translate }}</h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body pt-0" name="1DML-modal-body">
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light" [innerHTML]="multisimDeviceModalBody()"></span>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light">{{ 'multisim_select_eligible_line' | translate }}</span>
      </div>
    </div>
    <ul class="list-group multisim-lines-modal">
      @if (
        modal_asset?.device &&
        modal_asset?.line &&
        !['Inactive', 'Suspended'].includes(modal_asset!.line.status)
      ) {
        <li
          class="d-flex list-group-item list-group-item-action cursor-pointer"
          [ngClass]="{ active: lineInCart(modal_asset!.line) }"
          (click)="selectMultiSimLine(modal_asset!.line)"
        >
          {{ modal_asset?.line?.international_number }}
          ({{ modal_asset?.line?.carrier_name }})
          <span
            class="d-inline-block material-icons fs-inherit ms-1"
            [ngClass]="!lineInCart(modal_asset!.line) ? 'text-info' : ''"
          >
            verified
          </span>
        </li>
      }
      @for (additional_line of calculateModalAdditionalLines(modal_asset); track additional_line) {
        <li
          class="list-group-item list-group-item-action cursor-pointer"
          [ngClass]="{ active: lineInCart(additional_line) }"
          (click)="selectMultiSimLine(additional_line)"
        >
          {{ additional_line.international_number }} ({{ additional_line.carrier_name }})
        </li>
      }
    </ul>
  </div>
</ng-template>

<!-- 1LMD Modal -->
<ng-template #multiSimLineModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'multisim_line' | translate }}</h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body pt-0">
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light" [innerHTML]="multisimLineModalBody()"></span>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light">{{ 'multisim_select_eligible_device' | translate }}</span>
      </div>
    </div>
    <ul class="list-group multisim-devices-modal">
      @if (modal_asset?.device?.id) {
        <li
          class="d-flex list-group-item list-group-item-action cursor-pointer"
          [ngClass]="{ active: deviceInCart(modal_asset!.device) }"
          (click)="selectMultiSimDevice(modal_asset!.device)"
        >
          {{ modal_asset?.device?.manufacturer }}
          {{ modal_asset?.device?.model }}
          {{ modal_asset?.device?.size }}
          - {{ modal_asset?.device?.color }}
          <span
            class="d-inline-block material-icons fs-inherit ms-1"
            [ngClass]="!deviceInCart(modal_asset!.device) ? 'text-info' : ''"
          >
            verified
          </span>
        </li>
      }
      @for (
        additional_device of calculateModalAdditionalDevices(modal_asset);
        track additional_device
      ) {
        <li
          class="list-group-item list-group-item-action cursor-pointer"
          [ngClass]="{ active: deviceInCart(additional_device) }"
          (click)="selectMultiSimDevice(additional_device)"
        >
          {{ constructAdditionalDeviceTitle(additional_device) }}
        </li>
      }
    </ul>
  </div>
</ng-template>

<!-- Lost or Stolen Modal -->
<ng-template #isLostOrStolen let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'upgrade_device' | translate }}</h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body pt-0">
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light">{{ 'is_your_device_lost_or_stolen' | translate }}</span>
      </div>
    </div>
    <ts-listbox
      class="mb-3"
      [options]="device_lost_options"
      (selectionEvent)="isDeviceStolen($event)"
      aria-labelledby="ts-lost-stolen-listbox-label"
      aria-describedby="ts-lost-stolen-listbox-description"
    >
      <ng-template #listboxOption let-lostOrStolen>
        {{ lostOrStolen.name | translate }}
      </ng-template>
    </ts-listbox>
  </div>
</ng-template>
